export function redirectUser (path: string): void {
    // TO DISABLE REDIRECT COMMENT THE BELLOW LINE
    window.location.href = path
  }